import { useRouter } from "next/compat/router";
import { Loader } from "@cruk/cruk-react-components";

import { logIn } from "@fwa/src/services/auth";
import { useTracking } from "@fwa/src/hooks/useTracking";
import { useEffect, useRef } from "react";
import { isBrowser } from "@fwa/src/utils/browserUtils";

// Login works by redirecting the user to the oauth server and after log in being
// returned back to this page with the return url and auth code value in the query string

export const EnterPage = () => {
  const { trackError } = useTracking();
  const router = useRouter();
  const hasWindow = isBrowser;
  const isLoggingInRef = useRef(false);
  useEffect(() => {
    if (!hasWindow || isLoggingInRef.current || !router?.isReady) {
      return;
    }
    isLoggingInRef.current = true;
    // // strip out marketing tags from url
    router
      ?.push({
        pathname: router.pathname,
        query: {},
      })
      .then(() => {
        logIn();
        return undefined;
      })
      .catch(() => {
        trackError(new Error("unable to clear querystring"), {
          component: "EnterPage",
        });
      });
  }, [router, router?.isReady, trackError, hasWindow]);

  return <Loader />;
};
export default EnterPage;
